// extracted by mini-css-extract-plugin
module.exports = {"r-mobile":"CommonCard_r-mobile__MffXe","r-not-mobile":"CommonCard_r-not-mobile__R_Y_G","card":"CommonCard_card__s_Toc"};